// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/heros/hero-image_2-small.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/heros/hero-image_2-large.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Di bawah 549px */
@media screen and (max-width: 549px) {
  /* Navbar */
  .navbar-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }

  nav {
    z-index: 999;
    background-color: white;
    width: 180px;
    position: fixed;
    top: 130px;
    left: -100%;
    transition: left 0.3s ease;
  }

  nav .navbar-list {
    display: flex;
    flex-direction: column;
  }

  .open {
    left: 0;
  }

  .nav-item {
    display: block;
    text-align: center;
    padding: 0.6rem 0;
    border-bottom: 1px solid #e0e0e0;
    width: 100%;
    align-items: center;
  }

  nav .navbar-list li a {
    font-size: 15px;
  }

  .hamburger-icon {
    display: block;
    font-family: 'Rubik', sans-serif;
    font-size: 1.1rem;
    font-weight: 700;
    color: black;
    padding: 0.5rem 0.8rem;
    margin: 0.5rem auto;
    background-color: white;
    border-radius: 10%;
    min-width: 44px;
    min-height: 44px;
  }

  .hamburger-icon:hover {
    color: var(--primary);
    border-color: var(--primary);
    background-color: black;
  }
  /* End Navbar */

  /* Hero */

  .hero {
    height: 40vh;
    margin-top: 130px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }

  .hero .hero-text h1 {
    font-size: 1.5rem;
    text-align: center;
  }

  .hero .hero-text p {
    font-size: 13px;
  }

  .hero .hero-text .cta-container .cta {
    font-size: 13px;
    padding: 0.8rem 1rem;
  }
  /* End Hero */

  /* Content */
  main h2 {
    font-size: 1.3rem;
  }

  .card {
    height: 350px;
  }

  main .card-city {
    font-size: 1rem;
  }

  main .card-name {
    font-size: 1rem;
  }

  main .fa-star,
  main .card-rating {
    font-size: 1rem;
  }

  main .card-desc {
    font-size: 0.7rem;
  }
  /* End Content */

  /* to Top Icon */
  .to-top {
    right: 17px;
    width: 46px;
    height: 46px;
  }
  /* End to Top Icon */

  /* Footer */
  footer .menu a {
    font-size: 0.9rem;
  }

  footer .copyright p {
    font-size: 0.7rem;
  }
  /* End Footer */
}

/* Di atas 550px */
@media screen and (min-width: 550px) and (max-width: 1999px) {
  .navbar-container {
    position: fixed;
  }

  .hamburger-icon {
    display: none;
  }

  .hero {
    margin-top: 70px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}

/* Di atas 1200px */
@media screen and (min-width: 1200px) {
  .hero {
    min-width: 1000px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,WAAW;EACX;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,UAAU;IACV,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,4BAA4B;IAC5B,uBAAuB;EACzB;EACA,eAAe;;EAEf,SAAS;;EAET;IACE,YAAY;IACZ,iBAAiB;IACjB,yDAAoE;EACtE;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA,aAAa;;EAEb,YAAY;EACZ;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;EACA,gBAAgB;;EAEhB,gBAAgB;EAChB;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;EACA,oBAAoB;;EAEpB,WAAW;EACX;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,yDAAoE;EACtE;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Di bawah 549px */\n@media screen and (max-width: 549px) {\n  /* Navbar */\n  .navbar-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n  }\n\n  nav {\n    z-index: 999;\n    background-color: white;\n    width: 180px;\n    position: fixed;\n    top: 130px;\n    left: -100%;\n    transition: left 0.3s ease;\n  }\n\n  nav .navbar-list {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .open {\n    left: 0;\n  }\n\n  .nav-item {\n    display: block;\n    text-align: center;\n    padding: 0.6rem 0;\n    border-bottom: 1px solid #e0e0e0;\n    width: 100%;\n    align-items: center;\n  }\n\n  nav .navbar-list li a {\n    font-size: 15px;\n  }\n\n  .hamburger-icon {\n    display: block;\n    font-family: 'Rubik', sans-serif;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: black;\n    padding: 0.5rem 0.8rem;\n    margin: 0.5rem auto;\n    background-color: white;\n    border-radius: 10%;\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  .hamburger-icon:hover {\n    color: var(--primary);\n    border-color: var(--primary);\n    background-color: black;\n  }\n  /* End Navbar */\n\n  /* Hero */\n\n  .hero {\n    height: 40vh;\n    margin-top: 130px;\n    background-image: url(../public/images/heros/hero-image_2-small.jpg);\n  }\n\n  .hero .hero-text h1 {\n    font-size: 1.5rem;\n    text-align: center;\n  }\n\n  .hero .hero-text p {\n    font-size: 13px;\n  }\n\n  .hero .hero-text .cta-container .cta {\n    font-size: 13px;\n    padding: 0.8rem 1rem;\n  }\n  /* End Hero */\n\n  /* Content */\n  main h2 {\n    font-size: 1.3rem;\n  }\n\n  .card {\n    height: 350px;\n  }\n\n  main .card-city {\n    font-size: 1rem;\n  }\n\n  main .card-name {\n    font-size: 1rem;\n  }\n\n  main .fa-star,\n  main .card-rating {\n    font-size: 1rem;\n  }\n\n  main .card-desc {\n    font-size: 0.7rem;\n  }\n  /* End Content */\n\n  /* to Top Icon */\n  .to-top {\n    right: 17px;\n    width: 46px;\n    height: 46px;\n  }\n  /* End to Top Icon */\n\n  /* Footer */\n  footer .menu a {\n    font-size: 0.9rem;\n  }\n\n  footer .copyright p {\n    font-size: 0.7rem;\n  }\n  /* End Footer */\n}\n\n/* Di atas 550px */\n@media screen and (min-width: 550px) and (max-width: 1999px) {\n  .navbar-container {\n    position: fixed;\n  }\n\n  .hamburger-icon {\n    display: none;\n  }\n\n  .hero {\n    margin-top: 70px;\n    background-image: url(../public/images/heros/hero-image_2-large.jpg);\n  }\n}\n\n/* Di atas 1200px */\n@media screen and (min-width: 1200px) {\n  .hero {\n    min-width: 1000px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
